<template>
  <div class="page">
    <header-title title="Shipment Window"></header-title>
    <ul class="nav-list">
      <li
        @click="goRouter(item.url)"
        v-for="(item, index) in navItems"
        :key="item.url"
        :class="{ current: currentNavIndex === index }"
      >
        <div class="hd iconfont" :class="item.icon">
          <span class="txt">{{ item.text }}</span>
        </div>
      </li>
    </ul>
    <layout-content class="shipment-window" />
  </div>
</template>

<script setup>
  import HeaderTitle from '@/layout/header-title'
  import layoutContent from './components/content'
  import { computed } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  const route = useRoute()
  const router = useRouter()
  const navItems = [
    {
      icon: 'icon-data',
      url: '/shipment/master/master',
      text: 'Master Data',
    },
    {
      icon: 'icon-update',
      url: '/shipment/upload',
      text: 'Upload',
    },
    {
      icon: 'icon-leveling',
      url: '/shipment/preLeveling',
      text: 'Pre Leveling',
    },

    {
      icon: 'icon-shalou1',
      url: '/shipment/progress',
      text: 'Progress',
    },
    {
      icon: 'icon-input',
      url: '/shipment/input',
      text: 'Input',
    },
    {
      icon: 'icon-calendar-a',
      url: '/shipment/adjustment',
      text: 'Adjustment',
    },
  ]
  const goRouter = (url) => {
    router.push(url)
  }
  const currentNavIndex = computed(() => {
    if (route.path === '/shipment/master-data') {
      return 0
    } else {
      return navItems.findIndex((item) => item.url === route.path)
    }
  })
</script>

<style lang="less" scoped>
  @import '@/styles/variables.less';
  .page {
    height: calc(100% - 0px);
    ul,
    li {
      padding: 0;
      margin: 0;
      list-style: none;
    }
    .nav-list {
      display: flex;
      height: 50px;
      padding: 0;
      margin: 0;
      background: @master;
      li {
        flex: 1;
        padding: 0;
        text-align: center;
        cursor: pointer;
        .hd {
          height: 50px;
          padding: 15px;
          font-size: 18px;
          line-height: 1;
          color: rgba(255, 255, 255, 0.8);

          &.icon:before,
          &.iconfont:before {
            margin-right: 5px;
            line-height: 1;
          }
        }
        &.current {
          .hd {
            color: @started;
            border-bottom: 3px solid @started;
          }
        }
      }
    }
  }
</style>
